import { render, staticRenderFns } from "./PpLatestPage.vue?vue&type=template&id=fc963d8a&scoped=true&"
import script from "./PpLatestPage.vue?vue&type=script&lang=js&"
export * from "./PpLatestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc963d8a",
  null
  
)

export default component.exports